import { MultiselectTypes } from './../../constants';
import { MultiselectingItem } from '../../models/multiselecting-item.model';
import { EventEmitter, Injector, Input, Output, Component, TemplateRef, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { AbstractValueAccessor } from '../abstract-value-accessor';

@Component({
  selector: 'app-multiselectable-list',
  templateUrl: './multiselecting-list.component.html',
  styleUrls: ['./multiselecting-list.component.scss'],
})
export class MultiselectableListComponent extends AbstractValueAccessor implements OnChanges, OnInit {
  @Input()
  itemsList: MultiselectingItem[];

  @Input()
  type: MultiselectTypes = 'big';

  @Input()
  hasSelectAll = false;

  @Input()
  translationKey: string;

  @Input()
  itemTooltip: TemplateRef<any>;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  select = new EventEmitter<MultiselectingItem[]>();

  selectAllCheckmark = false;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    super.ngOnChanges(simpleChanges);
  }

  buildTranslationKey(relativeKey: string): string {
    return `${this.translationKey}.${relativeKey}`;
  }

  selectAll(checkmarkValue: boolean): void {
    this.itemsList.forEach((item) => {
      item.selected = checkmarkValue;
    });
    this.selectAllCheckmark = checkmarkValue;

    this.select.emit(checkmarkValue ? this.itemsList : null);
  }

  selectionItemHandler(item: MultiselectingItem): void {
    item.selected = !item.selected;
    this.select.emit([item]);
  }
}
